<div [class.justify-content-between]="isJustified()" [class.row]="isInline()" [class.align-items-center]="isInline()" [class.flex-row-reverse]="isReversed()">
  <div [class.text-end]="isInlineOnly()" [class.col-sm-2]="isInlineOnly()" [class.col-auto]="isInline()" [class.col-sm-10]="isReversed()">
    <label [class.col-form-label]="isInline()" class="form-label fw-bold">{{ name }}</label>
  </div>
  <div [class.col-sm-10]="isInlineOnly()" [class.col-auto]="isInline()" [class.col-sm-2]="isReversed()" [class.text-end]="isReversed()">
    <shared-ui-inputs-toggle-switch
      [tabIndex]="tabIndex"
      [disabled]="disabled"
      [parentFormGroup]="parentFormGroup"
      [formName]="formName"
      [name]="name"
      class="d-flex"
    ></shared-ui-inputs-toggle-switch>
  </div>
</div>
